
export default function SfpDirectAnswers() {
  return (
    <section style={{ padding: '60px 24px', background: '#ffffff' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        
        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#0f172a', marginBottom: '16px', fontWeight: 800 }}>
            What is Seller Fulfilled Prime on Amazon?
          </h2>
          <div style={{ padding: '16px', background: '#f8fafc', borderLeft: '4px solid #f97316', borderRadius: '4px' }}>
            <p style={{ margin: 0, color: '#475569', fontSize: '1.05rem', lineHeight: 1.6 }}>
              <strong>Direct Answer:</strong> Seller Fulfilled Prime (SFP) is an Amazon fulfilment programme that enables sellers to list products with the coveted Prime badge while fulfilling orders from their own warehouse or a 3PL partner, rather than using Amazon FBA.
            </p>
          </div>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#0f172a', marginBottom: '16px', fontWeight: 800 }}>
            What is Amazon Prime delivery in the UK?
          </h2>
          <div style={{ padding: '16px', background: '#f8fafc', borderLeft: '4px solid #f97316', borderRadius: '4px' }}>
            <p style={{ margin: 0, color: '#475569', fontSize: '1.05rem', lineHeight: 1.6 }}>
              <strong>Direct Answer:</strong> Amazon Prime delivery in the UK guarantees fast, free shipping (often next-day or same-day) for Prime members. For a seller to offer this, they must use either FBA or qualify for Seller Fulfilled Prime by meeting stringent dispatch and carrier SLAs.
            </p>
          </div>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#0f172a', marginBottom: '16px', fontWeight: 800 }}>
            Can I make $1000 a month selling on Amazon?
          </h2>
          <div style={{ padding: '16px', background: '#f8fafc', borderLeft: '4px solid #f97316', borderRadius: '4px' }}>
            <p style={{ margin: 0, color: '#475569', fontSize: '1.05rem', lineHeight: 1.6 }}>
              <strong>Direct Answer:</strong> Yes, making $1,000 (or £1,000) a month on Amazon is highly achievable through retail arbitrage, wholesale, or private label. Success depends on sourcing profitable products, optimising listings, and effectively managing fulfilment costs through 3PLs or FBA.
            </p>
          </div>
        </div>

        <div style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', color: '#0f172a', marginBottom: '16px', fontWeight: 800 }}>
            Is FBA still profitable in 2026?
          </h2>
          <div style={{ padding: '16px', background: '#f8fafc', borderLeft: '4px solid #f97316', borderRadius: '4px' }}>
            <p style={{ margin: 0, color: '#475569', fontSize: '1.05rem', lineHeight: 1.6 }}>
              <strong>Direct Answer:</strong> Yes, Amazon FBA remains profitable in 2026, provided sellers adapt to rising storage fees by using strict inventory management. Many top sellers now mix FBA with Seller Fulfilled Prime (via a 3PL) to reduce long-term storage penalties and maintain higher margins.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
